module.exports = __webpack_public_path__ + "static/media/thorn.8b844223.png";